import React from 'react';

const Exhibited = () => {
  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h1>Exhibited</h1>
      <p>Explore our exhibition services.</p>
    </div>
  );
};

export default Exhibited;
